import { render, staticRenderFns } from "./MRegister.vue?vue&type=template&id=5d418d9f&scoped=true&"
import script from "./MRegister.vue?vue&type=script&lang=js&"
export * from "./MRegister.vue?vue&type=script&lang=js&"
import style0 from "./MRegister.vue?vue&type=style&index=0&id=5d418d9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d418d9f",
  null
  
)

export default component.exports